// extracted by mini-css-extract-plugin
export default {"customLink":"ArticleList_customLink__JVQKB","secondaryLink":"ArticleList_secondaryLink__4ehJl","secondaryColor":"ArticleList_secondaryColor__UH8p1"};